import styled from "styled-components";

export const Container = styled.div`
    // width: 90%;
    // position: relative;
    // max-width: 1220px;
    // margin: auto;
   
    .premioContainer{
        margin-top: 6rem;
        display: grid;
        gap: 30px 22px;
        grid-template-columns: repeat(4, 1fr);
    }

   @media only screen and (max-width: 1280px) {
    .premioContainer{
        grid-template-columns: repeat(3, 1fr);
    }
   }
   @media only screen and (max-width: 1080px) {
    .premioContainer{
        grid-template-columns: repeat(2, 1fr);
    }
   }
   @media only screen and (max-width: 1080px) {
    .premioContainer{
        grid-template-columns: repeat(1, 1fr);
    }
   }

`;

